// Catálogo genérico de sub-opciones por rubro. Un rubro con entrada acá muestra un paso extra
// de sub-selección en el onboarding (ej. "Deporte y Fitness" → qué deportes ofrece la cuenta).
// Para agregar sub-opciones a otro rubro (ej. "Belleza" → sub-servicios), alcanza con sumar
// una entrada nueva; el step de onboarding y el guardado ya son genéricos.

export type RubroSubOption = { id: string; label: string };

export type RubroCatalogEntry = {
  /** Si permite elegir más de una sub-opción (ej. una cancha que ofrece varios deportes). */
  multiSelect: boolean;
  options: RubroSubOption[];
};

export const RUBRO_SUBOPTIONS: Record<string, RubroCatalogEntry> = {
  "Deporte y Fitness": {
    multiSelect: true,
    options: [
      { id: "padel", label: "Pádel" },
      { id: "futbol5", label: "Fútbol 5" },
      { id: "futbol11", label: "Fútbol 11" },
      { id: "basquet", label: "Básquet" },
      { id: "tenis", label: "Tenis" },
      { id: "voley", label: "Vóley" },
      { id: "squash", label: "Squash" },
      { id: "otro", label: "Otro" },
    ],
  },
};

export function rubroSubOptionLabel(rubro: string, id: string): string {
  const entry = RUBRO_SUBOPTIONS[rubro];
  return entry?.options.find((o) => o.id === id)?.label ?? id;
}
